import React from 'react'

const FormLangBar = ({currentLangList,formLang,setFormLang}) => {

    return (
        <>
            <div className='mb-4 flex gap-2 justify-end text-xs'>
                { currentLangList.map((lang) => (
                    <button
                        type="button"
                        onClick={()=>setFormLang(lang.langCode)}
                        className={`rounded-xl border px-3 py-1.5 transition-all duration-200 ${
                          formLang === lang.langCode
                            ? 'border-[#251658] bg-[#251658] text-white shadow-sm'
                            : 'border-slate-200 bg-white text-slate-600 hover:border-[#251658]/20 hover:bg-[#251658]/5 hover:text-[#251658]'
                        }`}
                        key={lang.langCode}
                    >
                        {lang.langName}
                    </button>
                )) }
            </div>
        </>
    )
}

export default FormLangBar
